import React, { useState } from "react";
import DumpTableSelector from "./DumpTableSelector";
import s from "./dump_styles/DumpCreateModal.module.css";

export default function DumpCreateModal({ onClose, onCreated }) {
  const [selectedTables, setSelectedTables] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleCreate = async () => {
    setIsLoading(true);
    try {
      const res = await fetch("/api/admin/dump/create", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          tables: selectedTables,
        }),
      });

      if (res.ok) {
        onClose();
        onCreated();
      } else {
        alert("Ошибка при создании дампа");
      }
    } catch (err) {
      console.error(err);
      alert("Ошибка соединения");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={s.modalOverlay}>
      <div className={s.modal}>
        <h3>Создать дамп</h3>
        <DumpTableSelector onChangeSelected={setSelectedTables} />
        <p style={{ color: "#888", marginTop: "10px" }}>
            Если не выбрано ни одной таблицы — будет создан дамп всей базы данных.
        </p>
        <div className={s.actions}>
          <button onClick={onClose}>Отмена</button>
          <button onClick={handleCreate} disabled={isLoading}>
            {isLoading ? "Создание..." : "Создать"}
          </button>
        </div>
      </div>
    </div>
  );
}
